import { render, staticRenderFns } from "./windows.vue?vue&type=template&id=b2702256&scoped=true&"
import script from "./windows.vue?vue&type=script&lang=js&"
export * from "./windows.vue?vue&type=script&lang=js&"
import style0 from "./windows.vue?vue&type=style&index=0&id=b2702256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2702256",
  null
  
)

export default component.exports